import apiClient from '../apiClient';

/**
 * Portal del Cliente - API Service
 * Gestiona todas las peticiones del portal del cliente
 */

// ============================================================================
// DASHBOARD
// ============================================================================

export const getPortalDashboard = async () => {
  const response = await apiClient.get('/portal/dashboard');
  return response.data;
};

// ============================================================================
// PERFIL
// ============================================================================

export const getPortalProfile = async () => {
  const response = await apiClient.get('/portal/profile');
  return response.data;
};

export const updatePortalProfile = async (data) => {
  const response = await apiClient.put('/portal/profile', data);
  return response.data;
};

// ============================================================================
// ÓRDENES
// ============================================================================

export const getPortalOrders = async (params = {}) => {
  const response = await apiClient.get('/portal/orders', { params });
  return response.data;
};

export const getPortalOrderById = async (orderId) => {
  const response = await apiClient.get(`/portal/orders/${orderId}`);
  return response.data;
};

export const createPortalOrder = async (orderData) => {
  const response = await apiClient.post('/portal/orders', orderData);
  return response.data;
};

// ============================================================================
// FACTURAS
// ============================================================================

export const getPortalInvoices = async (params = {}) => {
  const response = await apiClient.get('/portal/invoices', { params });
  return response.data;
};

export const getPortalInvoiceById = async (invoiceId) => {
  const response = await apiClient.get(`/portal/invoices/${invoiceId}`);
  return response.data;
};

export const downloadPortalInvoice = async (invoiceId) => {
  const response = await apiClient.get(`/portal/invoices/${invoiceId}/download`, {
    responseType: 'blob'
  });
  return response.data;
};

export const payPortalInvoice = async (invoiceId, paymentData) => {
  const response = await apiClient.post(`/portal/invoices/${invoiceId}/pay`, paymentData);
  return response.data;
};

// ============================================================================
// PRODUCTOS
// ============================================================================

export const getFrequentlyPurchased = async (params = {}) => {
  const response = await apiClient.get('/portal/products/frequently-purchased', { params });
  return response.data;
};

export const getNewProducts = async (params = {}) => {
  const response = await apiClient.get('/portal/products/new', { params });
  return response.data;
};

export const getProductsOnSale = async (params = {}) => {
  const response = await apiClient.get('/portal/products/on-sale', { params });
  return response.data;
};

export const getPortalCatalog = async (params = {}) => {
  const response = await apiClient.get('/portal/catalog', { params });
  return response.data;
};

/**
 * Productos públicos (sin autenticación)
 * Llama al endpoint público de productos del portal
 */
export const getPublicProducts = async (params = {}) => {
  const response = await apiClient.get('/portal/products/new', {
    params: { ...params, limit: params.limit || 10 }
  });
  return response.data;
};

// ============================================================================
// ALERTAS Y NOTIFICACIONES
// ============================================================================

export const getPortalAlerts = async () => {
  const response = await apiClient.get('/portal/alerts');
  return response.data;
};

export const getPortalNotifications = async (params = {}) => {
  const response = await apiClient.get('/portal/notifications', { params });
  return response.data;
};

export const markNotificationAsRead = async (notificationId) => {
  const response = await apiClient.put(`/portal/notifications/${notificationId}/read`);
  return response.data;
};

// ============================================================================
// SOPORTE
// ============================================================================

export const getSupportTickets = async (params = {}) => {
  const response = await apiClient.get('/portal/support/tickets', { params });
  return response.data;
};

export const createSupportTicket = async (ticketData) => {
  const response = await apiClient.post('/portal/support/tickets', ticketData);
  return response.data;
};

// ============================================================================
// PROYECTOS
// ============================================================================

export const getPortalProjects = async (params = {}) => {
  const response = await apiClient.get('/portal/projects', { params });
  return response.data;
};

// ============================================================================
// DOCUMENTOS
// ============================================================================

export const getPortalDocuments = async (params = {}) => {
  const response = await apiClient.get('/portal/documents', { params });
  return response.data;
};
